import { z } from 'zod';
import { JsonObjectSchema } from './common.js';
// =============================================================================
// Privacy - POPIA Compliance
// =============================================================================
export const SubjectTypeSchema = z.enum(['USER', 'ACCOUNT']);
export const DeletionRequestStatusSchema = z.enum(['PENDING', 'CANCELLED', 'PROCESSING', 'COMPLETED', 'FAILED']);
export const DomainDataSchema = z.object({
    domain: z.string(),
    category: z.string(),
    data: JsonObjectSchema,
});
export const RequestDataExportInputSchema = z.object({
    subjectType: SubjectTypeSchema,
    subjectId: z.string(),
});
export const DataExportResponseSchema = z.object({
    subjectType: SubjectTypeSchema,
    subjectId: z.string(),
    exportedAt: z.string(),
    data: z.array(DomainDataSchema),
});
export const RequestDeletionInputSchema = z.object({
    subjectType: SubjectTypeSchema,
    subjectId: z.string(),
    reason: z.string().optional(),
});
export const DeletionRequestSchema = z.object({
    id: z.string(),
    subjectType: SubjectTypeSchema,
    subjectId: z.string(),
    status: DeletionRequestStatusSchema,
    // Nullable so account-scoped list endpoints can redact the requestor's userId
    // when the request was initiated by a super admin (avoids leaking internal user IDs to account owners).
    requestedBy: z.string().nullable(),
    requestedAt: z.string(),
    gracePeriodDays: z.number(),
    scheduledFor: z.string(),
    processedAt: z.string().nullable(),
    completedAt: z.string().nullable(),
    failureReason: z.string().nullable(),
    reason: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
